import { Stack, StackProps } from '@mui/material';

import { LicenseDetailsCustomLabel, PagetitleProps } from './LicenseDetailsCustomLabel';

export interface LicenseDetailsHeaderColumnProps extends StackProps {
  rowItems: PagetitleProps[]
}

export const LicenseDetailsHeaderColumn = ({
    rowItems,
    spacing = 1,
    justifyContent = 'left',
    alignItems = 'flex-start',
    ...stackProps
}: LicenseDetailsHeaderColumnProps) => {
    const rowItemsToRender = rowItems.map(rowItem => (
        <LicenseDetailsCustomLabel
            key={`${rowItem.resourceName}.${rowItem.resourceValue}`}
            resourceName={rowItem.resourceName}
            resourceValue={rowItem.resourceValue}
            copyToClipboard={rowItem.copyToClipboard}
            addExtraSpaceBeforeValue={rowItem.addExtraSpaceBeforeValue}
        />
    ));

    return (
        <Stack
            spacing={spacing}
            justifyContent={justifyContent}
            alignItems={alignItems}
            {...stackProps}
        >
            {rowItemsToRender}
        </Stack>
    );
};
